import { useEffect } from 'react';
import { type UseFormReturn, useForm } from 'react-hook-form';
import { OpenFormAnswers } from '../OpenFormAnswers.js';
import { type OpenFormAsync } from '../OpenFormAsync.js';

export const setValueOptions = { shouldDirty: true, shouldTouch: true, shouldValidate: true } as const;

export const useOpenFormMethods = (async: typeof OpenFormAsync): UseFormReturn => {
  const methods = useForm({ mode: 'onBlur', reValidateMode: 'onBlur' });

  useEffect(() => {
    const { unsubscribe } = methods.watch((data, { name, values }) => {
      if (name && values) {
        const [question, key] = name.split('.', 2);
        if (!key) {
          async.actions.choices({ question, value: data[question] });
        } else if (OpenFormAnswers.isContext(key)) {
          async.actions.context({ question, key, patch: data[question]?.[key] });
        }
      }
    });
    return () => unsubscribe();
  }, [async, methods]);

  return methods;
};
